import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bae0acf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-primary full-pg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "display-3 fw-bold text-light",
  style: {"padding-top":"10vh"}
}, [
  /*#__PURE__*/_createTextVNode("We're a creative software"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("development agency")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  class: "fs-4 text-light pt-2",
  style: {"padding-left":"20%","padding-right":"20%"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-warning" }, "We're RhinoSoft."),
  /*#__PURE__*/_createTextVNode(" A team of talented developers, designers and business analysts who love using design and technology to help our partners perform beautifully.")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}